import {
  HttpClient,
  HttpContext,
} from '@angular/common/http';
import {
  inject,
  Injectable,
} from '@angular/core';
import type { Observable } from 'rxjs';

import { SKIP_AUTH } from '../../../core/interceptors/auth-http-context';
import { environment } from '../../../../environments/environment.development';
import type {
  ChangePasswordPayload,
  MeResponse,
  ObtainTokensPayload,
  TokensResponse,
} from '../models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  private readonly http = inject(HttpClient);

  obtainTokens(
    payload: ObtainTokensPayload,
  ): Observable<TokensResponse> {
    return this.http.post<TokensResponse>(
      `${environment.authUrl}/obtain-tokens`,
      payload,
      {
        context: new HttpContext().set(
          SKIP_AUTH,
          true,
        ),
      },
    );
  }

  me(): Observable<MeResponse> {
    return this.http.get<MeResponse>(
      `${environment.apiV1Url}/me`,
    );
  }

  updatePhoto(photo: string | null): Observable<MeResponse> {
    return this.http.patch<MeResponse>(
      `${environment.apiV1Url}/me`,
      { photo },
    );
  }

  changePassword(
    payload: ChangePasswordPayload,
  ): Observable<void> {
    return this.http.post<void>(
      `${environment.authUrl}/change-password`,
      payload,
    );
  }
}
